import { useMemo } from "react";
import {
  Breadcrumbs,
  Typography,
  Link,
  Stack,
  TablePagination,
} from "@mui/material";
import {
  PageTopBar,
  ThreeSlotLayout,
} from "../../../../../common/components/page_top_bar";
import { GenerateTermoEpiColumns } from "./columns/termo_epi";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";

import AlertError from "../../../../../common/components/alert_error";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../common/components/primary_button";
import RefreshButton from "../../../../../common/components/refresh_button";
import { useTermoEpiListaViewModel } from "../../viewModels/termo_epi_lista_view_model";
import { TermoEpi } from "../../../domain/models/termo_epi";
import { CadastroTermoEpiModal } from "./components/cadastro_termo_epi_modal";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { Header } from "./components/header";

export const TermoEpiLista = () => {
  const viewModel = useTermoEpiListaViewModel();

  const columns = useMemo(() => {
    return GenerateTermoEpiColumns({
      onActionEdit: viewModel.handleTermoEpiModalOpenState,
      onActionDelete: viewModel.handleDeleteTermoEpiModalOpenState,
    });
  }, [
    viewModel.handleDeleteTermoEpiModalOpenState,
    viewModel.handleTermoEpiModalOpenState,
  ]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[115px]">
                <PrimaryButton
                  startIcon={
                    <DynamicIcon
                      nameIcon="AddRounded"
                      size={25}
                      className="text-white"
                    />
                  }
                  onMouseDown={(e) => {
                    viewModel.handleTermoEpiModalOpenState(null, true);
                    e.preventDefault();
                  }}
                >
                  Novo
                </PrimaryButton>
              </div>
            </div>
          }
        />
      </PageTopBar>

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Gestão de EPI
          </Link>
          <Typography className="text-primary-green">Termo de EPI</Typography>
        </Breadcrumbs>

        <div className="flex flex-col gap-2">
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">
                Termo de EPI
              </h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>

            <div className="w-full justify-end flex gap-2"></div>
          </div>
        </div>
        {viewModel.errorMessage !== undefined ? (
          <div className="w-full">
            <AlertError
              messageErro={viewModel.errorMessage}
              onTryAgain={viewModel.handleReload}
            />
          </div>
        ) : (
          <>
            <Header
              nome={viewModel.filters.nome}
              status={viewModel.filters.status}
              onNomeChange={viewModel.handleNomeChange}
              onClearFilters={viewModel.handleClearFilters}
              handleStatusChange={viewModel.handleStatusChange}
            />

            <Stack spacing={0}>
              <TablePagination
                component="div"
                count={viewModel.pagination.totalItems}
                page={viewModel.pagination.page - 1}
                rowsPerPage={viewModel.pagination.rowsPerPage}
                rowsPerPageOptions={[10, 25, 50, 100]}
                onPageChange={(_, p) => viewModel.handlePageChange(p)}
                onRowsPerPageChange={(e) =>
                  viewModel.handleRowsPerPageChange(parseInt(e.target.value))
                }
              />

              <StyledDataGrid
                tableName="cadastro_epi"
                disableColumnMenu={false}
                getRowId={(row: TermoEpi) => row.idTermoEPI}
                columns={columns}
                loading={viewModel.loading}
                disableRowSelectionOnClick={true}
                rows={viewModel.termoEpiLista}
                rowCount={viewModel.termoEpiLista.length}
                getRowHeight={() => "auto"}
                pageSizeOptions={[10, 25, 50, 100]}
                paginationMode="server"
                paginationModel={{
                  page: viewModel.pagination.page,
                  pageSize: viewModel.pagination.rowsPerPage,
                }}
              />

              <TablePagination
                component="div"
                count={viewModel.pagination.totalItems}
                page={viewModel.pagination.page - 1}
                rowsPerPage={viewModel.pagination.rowsPerPage}
                rowsPerPageOptions={[10, 25, 50, 100]}
                onPageChange={(_, p) => viewModel.handlePageChange(p)}
                onRowsPerPageChange={(e) =>
                  viewModel.handleRowsPerPageChange(parseInt(e.target.value))
                }
              />
            </Stack>
          </>
        )}
      </div>

      <CadastroTermoEpiModal
        open={viewModel.termoEpiCadastroModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        handleOpenChangeHistory={() => null}
        selectedTermoEpi={viewModel.selectedTermoEpi}
        onClose={() => viewModel.handleTermoEpiModalOpenState(null, false)}
        onSubmit={viewModel.handleCadastroTermoEpiSubmit}
      />

      <DeleteDialog
        open={viewModel.termoEpiDeleteModal}
        title="Você realmente deseja excluir este item?"
        onClose={() =>
          viewModel.handleDeleteTermoEpiModalOpenState(null, false)
        }
        onDelete={() => viewModel.handleDeleteTermoEpiSubmit()}
      />
    </>
  );
};
